import { render, staticRenderFns } from "./TemplateInfoPage.vue?vue&type=template&id=407d6a01&scoped=true"
import script from "./TemplateInfoPage.vue?vue&type=script&lang=js"
export * from "./TemplateInfoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407d6a01",
  null
  
)

export default component.exports